

(function ($) {

    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    15/4/19
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function ($block) {
        initBlockJS();
    }

    // Initialize each block on page load (front end).
    $(document).ready(function () {
        if (!window.acf)
            initBlockJS();
    });

    // Initialize dynamic block preview (editor).
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=pathway-content', initializeBlock);
    }

    function initBlockJS() {
        // override overflow on body if .pathway_content_section exists so position sticky works on cta card
        if ($('.pathway_content_section').length) {
            $('body').css('overflow', 'visible');
        }

        // Benefits block accordion toggle
        $(document).off('click.benefits', '.js-pathway-benefits-toggle').on('click.benefits', '.js-pathway-benefits-toggle', function (e) {
            e.preventDefault();
            var $btn    = $(this);
            var $block  = $btn.closest('.benefits_block');
            var isOpen  = $btn.hasClass('is-open');
            $block.find('.benefits_accordion').toggleClass('is-open').attr('aria-hidden', isOpen ? 'true' : 'false');
            $btn.toggleClass('is-open').attr('aria-expanded', isOpen ? 'false' : 'true');
            $btn.find('.benefits_toggle_label').text(isOpen ? 'See all benefits' : 'See fewer benefits');
        });
    }

})(jQuery);


